import styled, { css } from 'styled-components';
import { getAutomatedStyleProp } from '../../providers/ComponentsThemeProvider';
import { Container as CheckboxIconContainer } from './CheckboxIcon/CheckboxIcon.styled';
export const Container = styled.div `
  display: flex;
  position: relative;
  user-select: none;
  align-items: center;

  & > * + * {
    margin-left: var(--space-300);
  }
`;
export const Label = styled.label `
  display: flex;

  & > * + * {
    margin-left: var(--space-300);
  }

  ${({ $labelAlign }) => $labelAlign === 'start' &&
    css `
      align-items: flex-start;
    `}

  ${({ $labelAlign }) => $labelAlign === 'center' &&
    css `
      align-items: center;
    `}

  ${({ $labelAlign }) => $labelAlign === 'end' &&
    css `
      align-items: flex-end;
    `}

  ${({ $disabled }) => !$disabled &&
    css `
      cursor: pointer;

      &:hover {
        ${CheckboxIconContainer} {
          border-color: ${getAutomatedStyleProp('colorPrimary', 'var(--border-active)')};
        }
      }
    `}

  ${({ $disabled }) => $disabled &&
    css `
      cursor: not-allowed;
    `}
`;
export const Input = styled.input `
  clip: rect(1px, 1px, 1px, 1px);

  position: absolute;
`;
export const Text = styled.div `
  display: flex;
  align-items: center;
  font-size: var(--font-size-400);
  line-height: var(--font-line-height-400);

  color: ${getAutomatedStyleProp('colorOnBackground', 'var(--text-primary)')};

  ${({ $disabled }) => $disabled &&
    css `
      color: ${getAutomatedStyleProp('paleTextColor', 'var(--text-secondary)')};
    `}
`;
export const Description = styled.div `
  color: var(--text-secondary);
  font-size: var(--font-size-300);

  a {
    text-decoration: underline;

    &:hover {
      color: var(--text-brand);
    }
  }
`;
export const TooltipContainer = styled.div `
  margin-left: var(--space-150);
`;
//# sourceMappingURL=styled.js.map